export default "__VITE_ASSET__D9A82wA3__"